export const bmiResultInCmAndKg = (weight, height) => {
    console.log(weight + " " + height)
    var heightDivded = height / 100;
    return weight / (heightDivded * heightDivded);
}

export const bmiResultInPoundsAndFeet = (weight, height) => {
    var heightDivded = (height * 30.48) / 100;
    return (weight / 2.2) / (heightDivded * heightDivded);
}

export const bmiResultInStonsAndFeet = (weight, height) => {
    var heightDivded = (height * 30.48) / 100;
    return (weight / 0.157473044) / (heightDivded * heightDivded);
}

export const bmiResultInPoundsAndInches = (weight, height) => {
    var heightDivded = (height / 0.393700787) / 100;
    return (weight /2.2) / (heightDivded * heightDivded);
}